<div class="borders" aria-label="Position the page within 4 white corners and take a picture">
  <div class="corners">
    <div class="corner-top-left"></div>
    <div class="corner-top-right"></div>
    <div class="corner-bottom-right"></div>
    <div class="corner-bottom-left"></div>
  </div>
  <div class="top blur"></div>
  <div class="row-align">
    <div class="left blur"></div>
    <div class="screen"></div>
    <div class="right blur"></div>
  </div>
  <div class="bottom blur"></div>
</div>
